'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageGrid = exports.Grid = exports.Collage = exports.Half = exports.Chapter = exports.Cover = exports.Main = exports.baseStyles = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n  }\n'], ['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n  }\n  [data-slot=\'B\'] {\n    ', ';\n  }\n'], ['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n  }\n  [data-slot=\'B\'] {\n    ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  [data-slot=\'B\'] {\n    ', ';\n    box-sizing: border-box;\n    padding: 0 2rem;\n  }\n'], ['\n  ', ';\n  [data-slot=\'B\'] {\n    ', ';\n    box-sizing: border-box;\n    padding: 0 2rem;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n    box-sizing: border-box;\n    padding: 0 2rem;\n  }\n'], ['\n  ', ';\n  [data-slot=\'A\'] {\n    ', ';\n    box-sizing: border-box;\n    padding: 0 2rem;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  [data-slot] {\n    box-sizing: border-box;\n    padding: 1rem;\n  }\n'], ['\n  ', ';\n  [data-slot] {\n    box-sizing: border-box;\n    padding: 1rem;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

var _layouts = require('./layouts');

Object.defineProperty(exports, 'baseStyles', {
  enumerable: true,
  get: function get() {
    return _layouts.baseStyles;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _master = require('@dekk/master');

var _text = require('@dekk/text');

var _text2 = _interopRequireDefault(_text);

var _image = require('@dekk/image');

var _layouts2 = _interopRequireDefault(_layouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A main slide
 * @type {Slide}
 */
var Main = exports.Main = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A' })
))(_templateObject, _layouts2.default.A, _layouts.vertical.center);

/**
 * A cover slide
 * @type {Slide}
 */
var Cover = exports.Cover = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A', only: [_text.Title] }),
  _react2.default.createElement(_master.Slot, { name: 'B', only: [_text.Subtitle] })
))(_templateObject2, _layouts2.default.AB.topBottom, _layouts.vertical.end, _layouts.vertical.start);

/**
 * A chapter slide
 * @type {Slide}
 */
var Chapter = exports.Chapter = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A', only: [_text.Title] }),
  _react2.default.createElement(_master.Slot, { name: 'B', only: [_text.Subtitle, _text2.default] })
))(_templateObject2, _layouts2.default.AB.topBottom, _layouts.vertical.end, _layouts.vertical.start);

/**
 * A 50/50 slide. (half image)
 * @type {Slide}
 */
var Half = exports.Half = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A', only: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'B', not: [_image.FitImage] })
))(_templateObject3, _layouts2.default.AB.leftRight, _layouts.vertical.start);

/**
 * A collage slide. (two images)
 * @type {Slide}
 */
var Collage = exports.Collage = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A', not: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'B', only: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'C', only: [_image.FitImage] })
))(_templateObject4, _layouts2.default.ABC.right, _layouts.vertical.start);

/**
 * A grid slide (4 slots)
 * @type {Slide}
 */
var Grid = exports.Grid = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A' }),
  _react2.default.createElement(_master.Slot, { name: 'B' }),
  _react2.default.createElement(_master.Slot, { name: 'C' }),
  _react2.default.createElement(_master.Slot, { name: 'D' })
))(_templateObject5, _layouts2.default.ABCD);

/**
 * An image gris slide (4 images)
 * @type {Slide}
 */
var ImageGrid = exports.ImageGrid = (0, _master.createStyledMaster)(_react2.default.createElement(
  _master.Master,
  null,
  _react2.default.createElement(_master.Slot, { name: 'A', only: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'B', only: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'C', only: [_image.FitImage] }),
  _react2.default.createElement(_master.Slot, { name: 'D', only: [_image.FitImage] })
))(_templateObject6, _layouts2.default.ABCD);
//# sourceMappingURL=index.js.map